module.exports = __webpack_public_path__ + "img/Pellets-gas.75f03fe.webp";